import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function OutstationLinks() {
  const [showLinks, setShowLinks] = useState(false);

  const toggleLinks = (e) => {
    e.preventDefault(); // Prevent page reload
    setShowLinks(!showLinks);
  };

  return (
    <div>
      <a
        href="#"
        className="outstation-link mx-md-2"
        onClick={toggleLinks}
      >
        <i className=" "></i> Pune to Outstation Cabs
      </a>

      {showLinks && (
        <div className="outstation- mt-2">
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Aurangabad-Cab-Booking"><i className="fa fa-car darkcolo"></i> Pune To Aurangabad Cab Booking</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Shirdi-Cab-Package"><i className="fa fa-car darkcolo"></i> Pune to Shirdi Cab Package</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Satara-Cab-Booking"><i className="fa fa-car darkcolo"></i> Pune To Satara Cab Booking</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Nasik-Cabs"><i className="fa fa-car darkcolo"></i> Pune to Nasik Cabs</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Wai-Panchgani"><i className="fa fa-car darkcolo"></i> Pune To Wai - Panchgani</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Saputara-Cab-Booking"><i className="fa fa-car darkcolo"></i> Pune To Saputara Cab Booking</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Nagpur-Cab"><i className="fa fa-car darkcolo"></i> Pune To Nagpur Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Jalana-Cab"><i className="fa fa-car darkcolo"></i> Pune To Jalana Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Lonavala-Cabs"><i className="fa fa-car darkcolo"></i> Pune to Lonavala Cabs</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Mahabaleshwar-Cab"><i className="fa fa-car darkcolo"></i> Pune To Mahabaleshwar Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Ajanta-Ellora-Tour-Package"><i className="fa fa-car darkcolo"></i> Pune to Ajanta Ellora Tour Package</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-Airport-to-Shirdi-Cab"><i className="fa fa-car darkcolo"></i> Pune Airport to Shirdi Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Goa-Cab-Booking"><i className="fa fa-car darkcolo"></i> Pune To Goa Cab Booking</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-Trimbakeshwar-Best-Cab"><i className="fa fa-car darkcolo"></i> Pune Trimbakeshwar Best Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Shirdi-Ertiga-Cab"><i className="fa fa-car darkcolo"></i> Pune to Shirdi Ertiga Cab</Link>
                                <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Shirdi-Cab"><i className="fa fa-car darkcolo"></i> Pune to Shirdi Cab</Link>
                                <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Alandi-Dehu-Darshan-Cab"><i className=" fa fa-car darkcolo"></i> Pune To Alandi - Dehu Darshan Cab</Link>
        
        </div>
      )}
    </div>
  );
}

export default OutstationLinks;
